import { FC } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';

import webView from 'common/webView';
import * as Form from 'components/_core/form';
import Text from 'components/_core/Text';

import { locales } from './locales';

interface InputFieldProps {
  label: string;
  inputProps: UseFormRegisterReturn;
  error?: string;
  displayTax?: boolean;
  placeholder?: string;
}

const InputField: FC<InputFieldProps> = ({
  displayTax = true,
  error,
  inputProps,
  label,
  placeholder,
}) => {
  const { isInWebView } = webView;

  return (
    <Flex
      alignItems={isInWebView ? 'start' : 'center'}
      flexDirection={isInWebView ? 'column' : 'row'}
      justifyContent="space-between"
      marginBottom="space-24"
    >
      <Text flex={2} fontSize="small" marginRight="space-8" variant="secondary">
        {label}
      </Text>
      <Flex
        alignItems="center"
        flex={1}
        gap="space-8"
        justifyContent="space-around"
        marginTop={isInWebView ? 'space-4' : undefined}
        w="100%"
      >
        <Form.Input
          textAlign={isInWebView ? 'left' : 'right'}
          {...inputProps}
          borderColor={error ? 'input-borderColor-invalid' : undefined}
          onFocus={(e) => e.target.select()}
          placeholder={placeholder ?? '0'}
          type="number"
        />
        <Text fontWeight="weight-500" variant="primary" whiteSpace="nowrap">
          {displayTax ? locales.withVat : locales.currency}
        </Text>
      </Flex>
    </Flex>
  );
};

export default InputField;
